import { useContext } from "react";
import { motion } from "framer-motion";
import { LanguageContext } from "../App";

export default function Intro() {
  const { t } = useContext(LanguageContext);

  return (
    <section
      id="intro"
      data-testid="intro-section"
      className="bg-[#FDFBF7] py-24 md:py-32 px-6"
    >
      <div className="max-w-3xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="font-['Cormorant_Garamond',serif] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-[#2A2726] leading-relaxed tracking-tight mb-5"
          data-testid="intro-text1"
        >
          {t.intro.text1}
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-['Manrope',sans-serif] text-base text-[#5C5754] leading-relaxed"
          data-testid="intro-text2"
        >
          {t.intro.text2}
        </motion.p>

        {/* Sage green accent line */}
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.4 }}
          className="w-12 h-px bg-[#7B907F] mx-auto mt-10 origin-center"
        />
      </div>
    </section>
  );
}
